/**
 * 半角数字のみであるかのvalidation
 * @param str 判定する文字列
 * @returns 判定結果
 */
export function validateHalfNumbers(str: string): boolean {
    const reg = new RegExp(/^[0-9]*$/);
    const res = reg.test(str);
    return res;
}
